import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit, isEmpty, scrollToComponent } from "@ui-seeker/utils"

import { useUserApp } from "@hooks"
import { USER_ROLES } from "@constants"
import { useStockShareRoleConfig } from "../../../@hooks";
import {stockShareSkuDetailsFilters} from "../../../signals";


export default function useStockShareSkuDetails() {
    const { showToast } = useAppToast()
    const { userRole, userUseRRSP } = useUserApp()
    const { urlApiSkuDetails } = useStockShareRoleConfig()

    const isLoadingDetailsTable = useSignal(false)
    const detailsTableData = useSignal([])

    useEffect(() => {
        if (!isEmpty(stockShareSkuDetailsFilters.value)) batch(() => {
            isLoadingDetailsTable.value = true
            showToast.promise(postSubmit(urlApiSkuDetails, stockShareSkuDetailsFilters.value).then(res => {
				detailsTableData.value = res
                isLoadingDetailsTable.value = false
			}).catch(() => {
				isLoadingDetailsTable.value = false
				showToast.error()
			}).finally(() => scrollToComponent('sku-details-table')))
        })
        else {
            detailsTableData.value = []
        }

    }, [JSON.stringify(stockShareSkuDetailsFilters.value)])

    const handleCloseDetailsSkuTable = () => {
        detailsTableData.value = []
        stockShareSkuDetailsFilters.value = {}
    }

    return {
        skuName: stockShareSkuDetailsFilters.value.skuName,
        country: stockShareSkuDetailsFilters.value.country?.length ? stockShareSkuDetailsFilters.value.country[0] : null,
        isLoadingDetailsTable: isLoadingDetailsTable.value,
        detailsTableData: detailsTableData.value,
        isStandardUser: userRole === USER_ROLES.STANDARD,
        userUseRRSP: userUseRRSP,
        urlApiSkuDetails: urlApiSkuDetails,
        handleCloseDetailsSkuTable: handleCloseDetailsSkuTable
    }
}